import { useState } from 'react';
import { Plane } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AirlineLogoProps {
  airlineCode: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZES = {
  sm: { container: 'w-6 h-6', icon: 'h-3 w-3' },
  md: { container: 'w-9 h-9', icon: 'h-4 w-4' },
  lg: { container: 'w-11 h-11', icon: 'h-5 w-5' },
};

export function AirlineLogo({ airlineCode, size = 'md', className }: AirlineLogoProps) {
  const [hasError, setHasError] = useState(false);
  const sizeConfig = SIZES[size];

  // Google Flights airline logo CDN
  const logoUrl = `https://www.gstatic.com/flights/airline_logos/70px/${airlineCode}.png`;

  if (hasError) {
    return (
      <div
        className={cn(
          sizeConfig.container,
          'rounded-full bg-slate-100 flex items-center justify-center',
          className
        )}
      >
        <Plane className={cn(sizeConfig.icon, 'text-slate-400')} />
      </div>
    );
  }

  return (
    <div
      className={cn(
        sizeConfig.container,
        'rounded-full bg-white shadow-sm flex items-center justify-center p-1',
        className
      )}
    >
      <img
        src={logoUrl}
        alt={airlineCode}
        className="w-full h-full object-contain"
        onError={() => setHasError(true)}
      />
    </div>
  );
}
